import styled from '@emotion/styled';
import * as React from 'react';
import { Z_INDEX } from '../../vars';
import { MenuItem } from './MenuItemWidget';
import { MenuSubItemWidget } from './MenuSubItemWidget';

export interface MenuSubItemsWidget {
  items: MenuItem[];
}

export const MenuSubItemsWidget: React.FC<MenuSubItemsWidget> = (props) => {
  const { items } = props;

  return (
    <S.SubItems>
      {items.map((i2, index) => (
        <MenuSubItemWidget item={i2} key={index} />
      ))}
    </S.SubItems>
  );
};

namespace S {
  export const SubItems = styled.div`
    display: flex;
    flex-direction: column;
    background: ${(p) => p.theme.header.dropdownBackground};
    margin-top: 5px;
    border-radius: 10px;
    z-index: ${Z_INDEX.MENU_SUB_ITEMS};
    padding: 10px;
    margin-left: -10px;
    border: solid 1px ${(p) => p.theme.header.dropdownBorder};
    box-shadow: ${(p) => p.theme.header.dropdownShadow};
  `;
}
